/**
 * Similar to globals, config, etc. this class has information about the
 * user's current bookmarks.
 */

import Backbone from 'backbone'

import _ from 'lodash'

var bookmarkUrls = []

var bookmarks = {

	// returns how many bookmarks the user has
	count: function() {
		return _.size(bookmarkUrls)
	},

	// return whether the url is already bookmarked
	has: function(url) {
		return bookmarkUrls.indexOf(url) > -1
	},

	// indicate that the  url is bookmarked
	add: function(url) {
		bookmarkUrls.push(url)
	},

	// indicate that the  url is no longer bookmark
	remove: function(url) {
		var index = bookmarkUrls.indexOf(url)
		if (index != -1) {
			bookmarkUrls.splice(index, 1)
		}
	}

}

function load(urls) {
	if (urls) {
		bookmarkUrls = urls
	}
}
Backbone.on('load', ({bookmarkUrls}) => load(bookmarkUrls))

_.extend(bookmarks, {
	load
})
export default bookmarks
export { load }

bookmarks.__filename__ = 'bookmarks/bookmarks.js'
